module.exports = __webpack_public_path__ + "media/media/distributors/beneficial_conditions-d0ca854e07040c054aed9e8f59331e03.png";